import script from "./trust-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./trust-bar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__